import { UPDATE_ROUTE } from '../actions'

type State = { isBlocked: boolean }

const initialState: State = { isBlocked: false }

export default function init (previousState = initialState, { type, payload }: { type: string; payload: boolean }) {
  return type === UPDATE_ROUTE ? { ...previousState, isBlocked: payload } : previousState
}
